module.exports = __webpack_public_path__ + "static/assets/709de1e4190e2fc8ef84100ad94157a4.png";